module.exports = __webpack_public_path__ + "img/visa.497c5c1a.png";